// extracted by mini-css-extract-plugin
module.exports = {"container":"PlainModal_container__3ERVZ","openModal":"PlainModal_openModal__9M1B3"};